import Vue from 'vue';
import axios from 'axios';
import Loading from 'quasar/src/plugins/Loading.js';;
export default {
  namespaced: true,
  state: {
    // 單篇貼文資料
    onePostData: {},
    // 是否已 load完 onePostData 的資料
    isFinishLoad: false
  },
  getters: {
    // 取得單篇貼文的資料
    getOnePostData: state => {
      return state.onePostData;
    },

    // 取得目前是否已 load 完 API 請求
    getOnePostLoadStatus: state => {
      return state.isFinishLoad;
    }
  },
  mutations: {
    // 存下單篇貼文資料
    SET_ONEPOST_DATA(state, data) {
      state.onePostData = data;
    },

    // 更新是否 load 完
    UPDATE_ONEPOST_LOADING_STATUS(state, data) {
      state.isFinishLoad = data;
    },

    // 更新此貼文的按讚狀態
    UPDATE_ONEPOST_LIKE_STATUS(state, flag) {
      state.onePostData.LikeIt = flag;
      // 讚數 + 或 - 1
      if (flag === 1) {
        state.onePostData.LikeCount += 1;
      } else {
        state.onePostData.LikeCount -= 1;
      }
    }
  },
  actions: {
    // 取得單篇貼文的資料
    getApiOnePostData(context, postId) {
      context.commit('UPDATE_ONEPOST_LOADING_STATUS', false);
      Loading.show();
      const api = `${process.env.VUE_APP_API_PATH}/showOnePost`;
      const formData = new FormData();
      formData.append('PostId', postId);
      axios
        .post(api, formData)
        .then(res => {
          context.commit('SET_ONEPOST_DATA', res.data);
          console.log('取得單篇貼文的資料');
          console.log(res.data);
          context.commit('UPDATE_ONEPOST_LOADING_STATUS', true);
          Loading.hide();
        })
        .catch(error => {
          console.error(error);
          Loading.hide();
        });
    }
  }
};
